import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Clock } from "lucide-react";
import { BRAND, ASSETS } from "../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="bg-brand-brown text-brand-ivory pt-20 pb-8 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={ASSETS.logo} alt="logo" className="h-16 w-16 object-contain bg-brand-ivory rounded-lg shadow-md" />
            <div>
              <div className="font-serif-display text-2xl">{BRAND.name}</div>
              <div className="text-[10px] tracking-[0.24em] uppercase text-brand-gold">
                {BRAND.tagline}
              </div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-brand-ivory/70 max-w-md">
            Premium nuts, chocolates, sweets, and dry fruits — crafted for everyday enjoyment,
            thoughtful gifting, and memorable occasions across the UAE.
          </p>
          <a
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 mt-6 text-sm text-brand-gold hover:text-[#E5C158] transition-colors"
          >
            <Instagram className="h-5 w-5" />
            @{BRAND.instagram}
          </a>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-brand-gold mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Products", "/products"],
              ["Gifting", "/gifting"],
              ["Gallery", "/gallery"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="hover:text-brand-gold transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-brand-gold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-brand-ivory/85">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-brand-gold shrink-0" />
              <a href={`tel:${BRAND.phone}`} className="hover:text-brand-gold" data-testid="footer-phone">
                {BRAND.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-0.5 text-brand-gold shrink-0" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-brand-gold break-all" data-testid="footer-email">
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="h-4 w-4 mt-0.5 text-brand-gold shrink-0" />
              <span>{BRAND.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 pt-6 border-t border-[#5A2F2A] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-ivory/60">
        <span>© {new Date().getFullYear()} {BRAND.name} Roastery. All rights reserved.</span>
        <span>Crafted with care · Dubai, UAE</span>
      </div>
    </footer>
  );
};
